var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmaIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.631,
    height: 79.633,
    viewBox: "0 0 93.631 79.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34353",
    "data-name": "Group 34353",
    transform: "translate(-771.121 -2752.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29771",
    "data-name": "Group 29771",
    transform: "translate(773 2753.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M3737.648,2881.914l-13.953-14.7v-21.172",
    transform: "translate(-3674.823 -2840.406)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M3643.26,2846.041l-.015,21.172-28.556,33.383a9.935,9.935,0,0,0,7.912,15.943h59.147a9.784,9.784,0,0,0,8.232-4.369",
    transform: "translate(-3612.647 -2840.406)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 26.443,
    transform: "translate(26.514)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M3648.452,2959.038h-17.238a2.747,2.747,0,0,1-2.071-4.552l17.262-20.154",
    transform: "translate(-3621.501 -2889.839)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M3785.834,2856.912v46.29a9.012,9.012,0,0,1-9.012,9.012h0a9.012,9.012,0,0,1-9.012-9.012v-46.29",
    transform: "translate(-3699.521 -2846.492)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 25.434,
    transform: "translate(64.569 3.83)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 2.457,
    transform: "translate(73.326 14.953)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 2.457,
    transform: "translate(73.326 25.271)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 2.457,
    transform: "translate(73.326 35.589)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 2.457,
    transform: "translate(73.326 45.906)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 25.257,
    transform: "translate(30.592 49.904)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    y2: 12.634,
    transform: "translate(36.697 5.635)",
    fill: "none",
    stroke: "#ffa764",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaIcon2);
export default __webpack_public_path__ + "static/media/pharma_icon2.efd59a7462478a3031780168b326d078.svg";
export { ForwardRef as ReactComponent };